window.FixedCTA = class {
  constructor(rootElement, triggerElement = false) {
    this.root = document.querySelector(rootElement);
    this.trigger = triggerElement ? document.querySelector(triggerElement) : false;
    this.initFixedCTA();
  }

  initFixedCTA() {
    if (!this.root) {
      console.error("Fixed CTA root element not found.");
      return;
    }

    this.button = this.root.querySelector('button[role="link"]');

    this.offset = this.trigger ? this.trigger.clientHeight + this.trigger.getBoundingClientRect().top : ((document.querySelector('.sitewide-banner') ? document.querySelector('.sitewide-banner').offsetHeight : 0) + (document.querySelector('#site-header').offsetHeight || 0));
    this.ctaType = this.button.dataset.nriAnchorId ? 'anchor' : 'url';

    this.button.addEventListener("click", () => {
      if (this.ctaType === 'anchor') {
        const anchorId = this.button.dataset.nriAnchorId
        this.scrollToAnchor(anchorId);
      } else {
        const url = this.button.dataset.nriUrl;
        window.location.href = url;
      }
    });

    this.applyActiveClass();
    window.addEventListener('scroll', () => {
      this.applyActiveClass();
    });
    window.addEventListener('resize', () => {
      this.offset = this.trigger ? this.trigger.clientHeight + this.trigger.getBoundingClientRect().top : ((document.querySelector('.sitewide-banner') ? document.querySelector('.sitewide-banner').offsetHeight : 0) + (document.querySelector('#site-header').offsetHeight || 0));
    });
  }

  scrollToAnchor(anchorId) {
    const anchor = document.querySelector('#' + anchorId);
    if (!anchor) {
      console.error("Anchor element not found.");
      return;
    }
    const y = anchor.getBoundingClientRect().top + window.scrollY - this.offset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }

  applyActiveClass() {
    const scrollPosition = window.scrollY;
    if (scrollPosition > this.offset) {
      if (this.ctaType === 'anchor') {
        const options = {
          root: null,
          rootMargin: '0px',
          threshold: 0.5 
        };
      
        const callback = (entries, observer) => {
          entries.forEach(entry => {
            const anchorId = this.button.dataset.nriAnchorId;
      
            if (entry.isIntersecting && anchorId) {
              // Hide the button wrapper if the section is visible
              this.root.classList.remove('active');
            } else {
              // Show the button wrapper if the section is not visible
              this.root.classList.add('active');
            }
          });
        };
      
        const observer = new IntersectionObserver(callback, options);
      
        const anchorId = this.button.dataset.nriAnchorId;
      
        if (anchorId) {
          const section = document.getElementById(anchorId);
      
          if (section) {
            observer.observe(section);
          }
        }
      } else {
        this.root.classList.add('active');
      }

    } else {
      this.root.classList.remove('active');
    }
  }
  
};
